window.HGW = window.HGW || {};

const HGW_PROGRESS_TTL = 1000 * 60 * 30; // 30분

function isHGWTestMode() {
  const url = new URL(window.location.href);

  if (url.searchParams.get("hgw_test") === "delivery") {
    sessionStorage.setItem("HGW_TEST_DELIVERY", "1");
  }

  return sessionStorage.getItem("HGW_TEST_DELIVERY") === "1";
}

/* ==========================
   Summary Method Toggle
========================== */

function toggleSummaryByMethod() {
  const summary = document.getElementById("hgw-summary");
  if (!summary) return;

  const method = HGW.state?.get?.().method;
  if (!method) return;

  summary.querySelectorAll("[data-method]").forEach(el => {
    const show = el.getAttribute("data-method") === method;

    // ✅ 둘 다 강제
    el.hidden = !show;
    el.style.display = show ? "" : "none";
  });
}

function addBusinessDays(isoDate, days) {
  if (!isoDate) return null;
  const [y,m,d] = isoDate.split("-").map(Number);
  if (!y || !m || !d) return null;

  const dt = new Date(y, m-1, d);
  let added = 0;

  while (added < days) {
    dt.setDate(dt.getDate() + 1);
    const day = dt.getDay();
    if (day !== 0 && day !== 6) added++;
  }

  const yyyy = dt.getFullYear();
  const mm = String(dt.getMonth()+1).padStart(2,"0");
  const dd = String(dt.getDate()).padStart(2,"0");
  return `${yyyy}-${mm}-${dd}`;
}

function formatAUDate(iso) {
  if (!iso) return "—";
  const [y,m,d] = iso.split("-").map(Number);
  const dt = new Date(y, m-1, d);
  return dt.toLocaleDateString("en-AU", { weekday:"short", day:"2-digit", month:"short" });
}

function getHGWDeliveryAreaDisplay(d = {}) {
  const area =
    d.area_label ||
    (typeof d.is_metro === "boolean"
      ? (d.is_metro ? "Perth Metro" : "WA Regional")
      : "");

  const zone = d.zone_label || "";

  if (area && zone) return `${area} · ${zone}`;
  return zone || area || "—";
}

HGW.core = {
  _boundOnce: false,

  /* ==========================
     Helpers (NEW + Existing)
  ========================== */

  // ✅ NEW: Step 내부에서 pickup/delivery UI 토글 (Step2 전용 토글 문제 해결)
  toggleStepByMethod(stepNumber) {
    try {
      const { method } = HGW.state.get();
      document
        .querySelectorAll(`[data-step="${stepNumber}"] [data-method]`)
        .forEach(el => {
          const show = el.dataset.method === method;
          el.hidden = !show;
          // 일부 CSS에서 hidden만으로 display가 남는 경우가 있어 강제
          el.style.display = show ? "" : "none";
        });
    } catch (e) {
      console.warn("[HGW] toggleStepByMethod failed:", e);
    }
  },

    getCartFlags() {
    const el = document.getElementById("hgw-cart-flags");

    return {
      hasColdDeliveryRestricted:
        el?.dataset?.hasColdDeliveryRestricted === "true",
      hasRefrigerated:
        el?.dataset?.hasRefrigerated === "true",
      hasFrozen:
        el?.dataset?.hasFrozen === "true",
      hasLiquor:
        el?.dataset?.hasLiquor === "true"
    };
  },

  isStep1DeliveryBlocked() {
    const s = HGW.state.get();
    const flags = this.getCartFlags();

    if (s.method !== "delivery") return false;

    return !!(
      flags.hasColdDeliveryRestricted ||
      flags.hasLiquor
    );
  },

  getStep1DeliveryBlockedMessage() {
    const flags = this.getCartFlags();
    const hasCold = !!flags.hasColdDeliveryRestricted;
    const hasLiquor = !!flags.hasLiquor;

    if (hasCold && hasLiquor) {
      return "Your cart contains refrigerated, frozen, or liquor items that are currently available for pickup only. Please choose pickup to continue.";
    }

    if (hasCold) {
      return "Your cart contains refrigerated or frozen items that are currently available for pickup only. Please choose pickup to continue.";
    }

    if (hasLiquor) {
      return "Your cart contains liquor items that are currently available for pickup only. Please choose pickup to continue.";
    }

    return "Some items in your cart are currently available for pickup only. Please choose pickup to continue.";
  },

  syncStep1DeliveryRestrictionUI() {
    const s = HGW.state.get();
    const warningEl = document.getElementById("hgw-step1-delivery-warning");
    const warningTextEl = document.getElementById("hgw-step1-delivery-warning-text");
    const btnNext = document.querySelector(".hgw-btn-next");
    const deliveryRadio = document.getElementById("hgw-method-delivery");

    const blocked = this.isStep1DeliveryBlocked();
    const isStep1 = Number(s.step) === 1;

    if (warningEl) {
      warningEl.hidden = !(isStep1 && blocked);
    }

    if (warningTextEl && blocked) {
      warningTextEl.textContent = this.getStep1DeliveryBlockedMessage();
    }

    // 카드 시각 강조용 (선택사항이지만 추천)
    if (deliveryRadio) {
      const card = deliveryRadio.closest("div")?.querySelector(".hgw-card") || deliveryRadio.closest(".hgw-card");
      if (card) {
        card.classList.toggle("is-blocked", isStep1 && blocked);
      }
    }

    // 여기서는 막기만 하고, 다시 활성화는 validate()가 최종 결정
    if (btnNext && isStep1 && blocked) {
      btnNext.disabled = true;
    }
  },

  getStores() {
    // New unified metaobject
    if (Array.isArray(window.HGW_STORES)) return window.HGW_STORES;

    // Legacy fallback
    const legacy = window.HGW_PICKUP_STORES || [];
    return legacy.map(s => ({
      code: s.code,
      display_name: s.name,
      pickup: { enabled: true, schedule: null },
      delivery: { enabled: false }
    }));
  },

  getStoreByCode(code) {
    if (!code) return null;
    return this.getStores().find(s => String(s.code) === String(code)) || null;
  },

  /**
   * Returns pickup schedule in a way that works for both:
   * - new store_fulfillment: store.pickup.schedule (JSON)
   * - legacy: window.HGW_PICKUP_SCHEDULES filtered by store_code
   */
  getPickupScheduleForStore(storeCode) {
    const store = this.getStoreByCode(storeCode);
    if (store?.pickup?.schedule) return store.pickup.schedule;

    // legacy fallback
    const all = window.HGW_PICKUP_SCHEDULES || [];
    return all.filter(x => String(x.store_code) === String(storeCode));
  },

  /* ==========================
     STEP 2: Store Populate
  ========================== */

  populatePickupStores() {
    const select = document.getElementById("pickup-store");
    if (!select) return;

    select.innerHTML = `<option value="">Select store</option>`;

    // ✅ Only active + pickup enabled stores
    const stores = this.getStores()
      .filter(s => {
        const code = String(s?.code || "").toLowerCase().trim();
        const enabled = s?.pickup?.enabled;

        // 안전장치: Booragoon은 무조건 픽업 목록에서 제외
        if (code === "booragoon") return false;

        // Shopify/Liquid에서 boolean이 문자열로 들어오는 경우까지 처리
        if (enabled === true) return true;
        if (enabled === "true") return true;
        if (enabled === 1) return true;
        if (enabled === "1") return true;

        return false;
      })
      .sort((a, b) => (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0));

    stores.forEach(store => {
      const opt = document.createElement("option");
      opt.value = store.code;
      opt.textContent = store.display_name || store.location_name || store.code;
      select.appendChild(opt);
    });
  },

  /* ==========================
     Summary Rendering
  ========================== */

  renderSummary() {
    const s = HGW.state.get();
    const root = document.getElementById("hgw-summary");
    if (!root) return;

    const store = this.getStoreByCode(s.store);

    root.querySelector('[data-summary="store"]').textContent =
      store?.display_name || store?.location_name || "-";

    root.querySelector('[data-summary="date"]').textContent =
      HGW.utils.formatSummaryDate(s.date);

    root.querySelector('[data-summary="time"]').textContent =
      s.time || "-";
  },

  bindSummaryChange() {
    const summary = document.getElementById("hgw-summary");
    if (!summary) return;

    summary.addEventListener("click", e => {
      const btn = e.target.closest("[data-change-step]");
      if (!btn) return;

      const step = Number(btn.dataset.changeStep);
      if (!step) return;

      e.preventDefault();
      e.stopPropagation();
      this.goStep(step);
    });
  },

  bindSummaryHome() {
    const summary = document.getElementById("hgw-summary");
    if (!summary) return;

    summary.addEventListener("click", e => {
      const btn = e.target.closest("[data-summary-home]");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      // 🔥 Step 1로 이동
      this.goStep(1);

      // 상태 유지 (초기화 안함)
      // 완전 초기화 원하면 여기서 HGW.state.reset() 호출
    });
  },

  renderDeliverySummary() {
    const s = HGW.state.get();
    const d = s.delivery || {};

    const set = (key, value) => {
      const el = document.querySelector(`[data-summary="${key}"]`);
      if (!el) return;
      el.textContent = (value ?? "").toString().trim() || "—";
    };

    const toMoneyText = (raw) => {
      if (raw == null || raw === "") return "—";

      let num = null;

      if (typeof raw === "number") {
        num = raw;
      } else if (typeof raw === "string") {
        const cleaned = raw.replace(/[^0-9.]/g, "");
        if (cleaned) num = Number(cleaned);
      }

      if (num == null || Number.isNaN(num)) return "—";
      return `$${num.toFixed(2)}`;
    };

    // 1) Delivery address
    const fullAddress = [
      d.address || s.address,
      d.suburb || s.suburb,
      d.postcode || s.postcode
    ].filter(Boolean).join(", ");
    set("delivery_address", fullAddress);

    // 2) Dispatch date
    set(
      "dispatch_date",
      HGW.utils.formatSummaryDate(d.dispatch_date)
    );

    // 3) Delivery area
    set("delivery_area", getHGWDeliveryAreaDisplay(d));

    /* =========================================
      4) Delivery time (policy based)
      템플릿 키: estimated_delivery
    ========================================= */

    let etaText = "—";

    const policy = HGW.deliveryPolicy;

    if (policy) {

      const serviceArea = d.is_metro ? "metro" : "regional";
      const rule = policy.zone_rules?.[serviceArea];

      if (rule && rule.eta_min && rule.eta_max) {

        if (rule.eta_min === rule.eta_max) {
          etaText = `${rule.eta_min} business day`;
        } else {
          etaText = `${rule.eta_min}–${rule.eta_max} business days`;
        }

      } else {

        // fallback (혹시 JSON 없을 경우)
        const fallbackMin = d.is_metro
          ? policy.metro_eta_days
          : policy.regional_eta_days;

        if (fallbackMin) {
          etaText = `${fallbackMin} business days`;
        }
      }
    }

    set("estimated_delivery", etaText);

    // 5) Parcels ✅ 템플릿 키: parcel_info
    const parcelCount = d.parcel_count ?? s.parcel_count;
    const boxSummary = d.box_summary ?? s.box_summary;

    let parcelText = "—";
    if (parcelCount != null && parcelCount !== "") {
      const n = Number(parcelCount);
      parcelText = Number.isNaN(n) ? "—" : `${n}${boxSummary ? ` (${boxSummary})` : ""}`;
    }
    set("parcel_info", parcelText);

    // 6) Shipping total (promo display)
    const parcelCountForShipping = Number(d.parcel_count || 1);
    const baseShipping = 9.99;
    const extraParcelCost = Math.max(0, parcelCountForShipping - 1) * 5;
    const surchargeTotal =
      (d.surcharges && typeof d.surcharges === "object")
        ? Object.values(d.surcharges).reduce(
            (sum, v) => sum + (Number(v) || 0),
            0
          )
        : 0;

    let costHTML = "—";

    if (parcelCountForShipping >= 1) {
      if (extraParcelCost > 0) {
        costHTML =
          `$${baseShipping.toFixed(2)} ` +
          `+ <span style="text-decoration:line-through;color:#999;">$${extraParcelCost.toFixed(2)}</span>`;
      } else {

        costHTML = `$${baseShipping.toFixed(2)}`;
      }

      if (surchargeTotal > 0) {
        costHTML += ` + $${surchargeTotal.toFixed(2)}`;
      }
    }

    const el = document.querySelector('[data-summary="shipping_total"]');
    if (el) el.innerHTML = costHTML;

    // 7) Signature required ✅ 템플릿 키: signature (제거함)
  },

  /* ==========================
     Popup Open / Close
  ========================== */

  async open(goCheckout) {

    const root = document.getElementById("hgw-cart-popup-root");
    if (!root) return;

    root.innerHTML = window.HGW_POPUP_TEMPLATE;

    const overlay = document.getElementById("hgw-overlay");
    if (overlay) overlay.style.opacity = "0";

    document.body.style.overflow = "hidden";

    /* =====================================
      Delivery state validation
    ===================================== */

    const state = HGW.state.get();

    if (state.method === "delivery") {

      const d = state.delivery || {};

      if (d.base_shipping_cost == null || d.parcel_count == null) {

        console.log("[HGW] invalid delivery state → reset to Step2");

        HGW.state.update({
          step: 2
        });

      }

    }

    if (window.HGW_SHIPPING_ENDPOINT) {
      fetch(window.HGW_SHIPPING_ENDPOINT + "/health", {
        method: "GET",
        mode: "cors",
        cache: "no-store"
      }).catch(() => {});
    }

    // Delivery test mode 처리
    const deliveryRadio = document.getElementById("hgw-method-delivery");

    if (deliveryRadio) {
      deliveryRadio.disabled = false;
      deliveryRadio.closest(".hgw-card")?.classList.remove("is-disabled");
    }    

    if (isHGWTestMode()) {
      document
        .querySelectorAll(".hgw-card-badge")
        .forEach(badge => badge.remove());
    }

    // Step 2 store 옵션
    this.populatePickupStores();

    // 바인딩
    HGW.bindings.bind();
    this.bindCloseHandlers();
    this.bindSummaryChange();
    this.bindSummaryHome();

    if (HGW.checkout?.bind) {
      HGW.checkout.bind();
    }

    const restoredStep = this.restoreProgress();
    const targetStep = restoredStep || goCheckout || 1;
    const forcedStep = this.hydrateInputsFromState();

    if (forcedStep) {
      this._skipPersistStep = true;
      this.goStep(forcedStep);
      this._skipPersistStep = false;
    } else {
      this.goStep(targetStep);
    }

    this.validate();

    requestAnimationFrame(() => {
      const overlay = document.getElementById("hgw-overlay");
      if (overlay) overlay.style.opacity = "1";
    });
  },

  close() {
    this.persistProgress();

    const root = document.getElementById("hgw-cart-popup-root");
    if (root) root.innerHTML = "";

    document.body.style.overflow = "";
  },

  /* ==========================
     Close Handlers
  ========================== */

  bindCloseHandlers() {
    if (this._boundOnce) return;
    this._boundOnce = true;

    document.addEventListener("keydown", e => {
      if (e.key === "Escape") {
        const overlay = document.getElementById("hgw-overlay");
        if (overlay) this.close();
      }
    });

    document.addEventListener("click", e => {
      const overlay = document.getElementById("hgw-overlay");
      if (overlay && e.target === overlay) this.close();

      const btn = e.target.closest("#hgw-close");
      if (btn) {
        e.preventDefault();
        this.close();
      }
    });
  },

  /* ==========================
     Step Control
  ========================== */

  goStep(step) {
    const currentStep = Number(step) || 1;

    document.querySelectorAll(".hgw-step").forEach(el => {
      el.style.display =
        Number(el.dataset.step) === currentStep ? "block" : "none";
    });

    this.toggleStepByMethod(currentStep);

    /* ==========================
      Auto render time slots on step 4
    ========================== */

    if (currentStep === 4) {
      const s = HGW.state.get();

      if (
        s.method === "pickup" &&
        s.store &&
        s.date &&
        HGW.schedule?.buildSlots &&
        HGW.timewheel?.render
      ) {
        const store = this.getStoreByCode(s.store);
        const pickupSchedule = this.getPickupScheduleForStore(s.store);

        const ctx = {
          storeSelect: document.getElementById("pickup-store"),
          dateInput: document.getElementById("pickup-date"),
          dateDisplay: document.getElementById("pickup-date-display"),
          calendar: document.getElementById("pickup-date-calendar"),
          wheel: document.getElementById("pickup-time-wheel"),
          wheelInner: document.querySelector(".hgw-time-wheel-inner"),
          store,
          schedules: pickupSchedule
        };

        const slots = HGW.schedule.buildSlots({
          store,
          dateStr: s.date
        });

        HGW.timewheel.render(ctx, slots);

        if (HGW.timewheel.selectByValue && s.time) {
          HGW.timewheel.selectByValue(s.time);
        }
      }
    }

    if (currentStep === 2 && typeof renderStep2ByMethod === "function") {
      renderStep2ByMethod();
    }

    if (currentStep === 2 && typeof window.HGW_loadGoogleMapsPlaces === "function") {
      window.HGW_loadGoogleMapsPlaces();
    }

    try {
      const s = HGW.state.get();

      if (currentStep === 3 && s.method === "delivery" && HGW.delivery?.renderStep3) {
        HGW.delivery.renderStep3();
      }

      if (currentStep === 4 && s.method === "delivery" && HGW.delivery?.renderStep4) {
        HGW.delivery.renderStep4();
      }
    } catch (e) {
      console.warn("[HGW] delivery step hook failed:", e);
    }

    const btnPrev = document.querySelector(".hgw-btn-prev");
    const btnNext = document.querySelector(".hgw-btn-next");
    const btnConfirm = document.getElementById("hgw-confirm");

    if (btnPrev) btnPrev.style.display = currentStep > 1 ? "inline-flex" : "none";
    if (btnNext) btnNext.style.display = currentStep < 5 ? "inline-flex" : "none";
    if (btnConfirm)
      btnConfirm.style.display = currentStep === 5 ? "inline-flex" : "none";

    document.querySelectorAll(".hgw-progress-step").forEach(el => {
      const s = Number(el.dataset.step);
      el.classList.toggle("is-active", s === currentStep);
      el.classList.toggle("is-done", s < currentStep);
    });

    document.querySelectorAll(".hgw-progress-line").forEach((line, i) => {
      line.classList.toggle("is-done", i < currentStep - 1);
    });

    const footer = document.querySelector(".hgw-footer");
    if (footer) {
      footer.className = `hgw-footer step-${currentStep}`;
    }

    const summary = document.getElementById("hgw-summary");
    if (summary) {
      summary.style.display = currentStep === 5 ? "block" : "none";

      if (currentStep === 5) {
        const method = HGW.state.get().method;

        toggleSummaryByMethod();

        if (method === "pickup") {
          this.renderSummary();
        }

        if (method === "delivery" && typeof this.renderDeliverySummary === "function") {
          this.renderDeliverySummary();
        }

        requestAnimationFrame(() => {

        if (typeof window.initMobileSummaryAccordion === "function") {
          window.initMobileSummaryAccordion();
        }

        if (typeof window.initDesktopNoteToggle === "function") {
          window.initDesktopNoteToggle();
        }

      });
      }
    }

    if (!this._skipPersistStep) {
      HGW.state?.update({ step: currentStep });
    }

    this.validate();

    if (currentStep === 1) {
      this.syncStep1DeliveryRestrictionUI();
    }
  },

  /* ==========================
     Validation
  ========================== */

  validate() {
    const s = HGW.state.get();

    const btnConfirm = document.getElementById("hgw-confirm");
    const btnNext = document.querySelector(".hgw-btn-next");

    if (btnNext) btnNext.disabled = false;

    if (!btnConfirm) return false;

    if (s.step !== 5) {
      btnConfirm.disabled = true;
    }

    /* --------------------------
       NEW: Next 버튼 단계별 gate
       (Delivery Step3/4 필수 조건)
    -------------------------- */

    if (s.step === 1) {
      if (btnNext) {
        btnNext.disabled = false;
      }

      if (!s.method && btnNext) {
        btnNext.disabled = true;
      }

      if (this.isStep1DeliveryBlocked() && btnNext) {
        btnNext.disabled = true;
      }

      this.syncStep1DeliveryRestrictionUI();
    }

    if (s.step === 2) {
      if (s.method === "pickup") {
        if (!s.store && btnNext) btnNext.disabled = true;
      }

      if (s.method === "delivery") {
        const d = s.delivery || {};

        const addrOk = !!(d.address || s.address);
        const subOk = !!(d.suburb || s.suburb);
        const postOk = !!(d.postcode || s.postcode);

        if (btnNext) {
          if (d.calc_status === "loading") {
            btnNext.disabled = true;
            btnNext.textContent = "Calculating...";
            return;
          }

          // 주소 3종만 있으면 Next 허용
          if (!(addrOk && subOk && postOk)) {
            btnNext.disabled = true;
            btnNext.textContent = "Next";
          } else {
            btnNext.disabled = false;
            btnNext.textContent = "Next";
          }
        }
      }
    }

    if (s.step === 3 && s.method === "delivery") {
      if (!s.delivery?.policy_agreed && btnNext) btnNext.disabled = true;
    }

    if (s.step === 4 && s.method === "delivery") {
      if (!s.delivery?.dispatch_date && btnNext) btnNext.disabled = true;
    }

    /* --------------------------
       Confirm 버튼 기존 검증(필요 최소 수정)
    -------------------------- */

    if (s.step !== 5) {
      return false;
    }

    if (s.method === "delivery") {
      const addrOk = !!(s.delivery?.address || s.address);
      const policyOk = !!s.delivery?.policy_agreed;
      const dispatchOk = !!s.delivery?.dispatch_date;
      const finalizedOk = !!s.delivery?.finalized;
      btnConfirm.disabled = !(addrOk && policyOk && dispatchOk && finalizedOk);
      return !btnConfirm.disabled;
    }

    if (!(s.store && s.date && s.time)) {
      btnConfirm.disabled = true;
      return false;
    }

    if (HGW.schedule?.buildSlots) {
      const store = this.getStoreByCode(s.store);

      const slots = HGW.schedule.buildSlots({
        store,
        dateStr: s.date
      });

      const valid = slots?.some(
        slot => !slot.disabled && slot.value === s.time
      );

      if (!valid) {
        btnConfirm.disabled = true;
        return false;
      }
    }

    btnConfirm.disabled = false;
    return true;
  },

    buildCartAttributes() {
    const s = HGW.state.get();
    const d = s.delivery || {};

    return {
      fulfillment_type: s.method || "",

      pickup_store: s.method === "pickup"
        ? (s.store || "")
        : "",

      pickup_store_code: s.method === "pickup"
        ? (s.store || "")
        : "",

      pickup_store_name: s.method === "pickup"
        ? (
            this.getStoreByCode(s.store)?.display_name ||
            this.getStoreByCode(s.store)?.location_name ||
            s.store ||
            ""
          )
        : "",

      pickup_date: s.method === "pickup"
        ? (s.date || "")
        : "",

      pickup_time: s.method === "pickup"
        ? (s.time || "")
        : "",

      order_note: s.note || "",

      delivery_address: s.method === "delivery"
        ? (d.address || "")
        : "",

      delivery_suburb: s.method === "delivery"
        ? (d.suburb || "")
        : "",

      delivery_postcode: s.method === "delivery"
        ? (d.postcode || "")
        : "",

      delivery_address_extra: s.method === "delivery"
        ? (d.address_extra || "")
        : "",

      delivery_area: s.method === "delivery"
        ? getHGWDeliveryAreaDisplay(d)
        : "",

      delivery_zone: s.method === "delivery"
        ? (d.zone_label || "")
        : "",

      delivery_zone_code: s.method === "delivery"
        ? (d.zone_code != null ? String(d.zone_code) : "")
        : "",

      dispatch_date: s.method === "delivery"
        ? (d.dispatch_date || "")
        : "",

      signature_required: s.method === "delivery"
        ? (d.signature_required ? "yes" : "no")
        : "",

      shipping_cost: s.method === "delivery"
        ? (d.final_shipping_cost != null ? String(d.final_shipping_cost) : "")
        : ""
    };
  },

  async saveCartAttributes() {
    const attributes = this.buildCartAttributes();

    console.log("[HGW] saving cart attributes", attributes);

    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ attributes })
    });

    if (!res.ok) {
      throw new Error("Failed to save cart attributes");
    }

    const cart = await res.json();
    console.log("[HGW] cart attributes saved", cart.attributes);
    return cart;
  },

  /* ==========================
     Persist / Restore
  ========================== */

  persistProgress: async function () {
    try {
      const s = HGW.state.get();
      const cartSig = await this.getCartSignature();

      localStorage.setItem(
        "HGW_PICKUP_PROGRESS",
        JSON.stringify({
          ...s,
          step: Number(s.step) || 1,
          _ts: Date.now(),
          _cart_sig: cartSig
        })
      );
    } catch (_) {}
  },

  restoreProgress() {
    try {
      const raw = localStorage.getItem("HGW_PICKUP_PROGRESS");
      if (!raw) return 1;

      const saved = JSON.parse(raw);

      if (!saved._ts || Date.now() - saved._ts > HGW_PROGRESS_TTL) {
        localStorage.removeItem("HGW_PICKUP_PROGRESS");
        HGW.state.reset();
        return 1;
      }

      HGW.state.update({
        method: saved.method || "",
        store: saved.store || "",
        date: saved.date || "",
        time: saved.time || "",
        note: saved.note || "",
        delivery: saved.delivery || {},
        step: saved.step || 1
      });

      const computed = this.computeStepFromState(saved);
      const stored = Number(saved.step) || 1;

      // 저장된 step을 우선 존중
      if (stored < computed) {
        return stored;
      }

      return computed;

    } catch (_) {
      return 1;
    }
  },

  computeStepFromState(s) {
    if (!s?.method) return 1;
    if (s.method === "delivery") {
      if (!s.delivery?.address) return 2;
      if (!s.delivery?.policy_agreed) return 3;
      if (!s.delivery?.dispatch_date) return 4;
      if (!s.delivery?.finalized) return 4;
      return 5;
    }
    if (!s.store) return 2;
    if (!s.date) return 3;
    if (!s.time) return 4;
    return 5;
  },

  /* ==========================
     Hydration
  ========================== */

  hydrateInputsFromState() {
    let forcedStep = null;
    const s = HGW.state.get();

    const rDelivery = document.getElementById("hgw-method-delivery");
    const rPickup = document.getElementById("hgw-method-pickup");

    if (rDelivery) rDelivery.checked = s.method === "delivery";
    if (rPickup) rPickup.checked = s.method === "pickup";

    const storeSelect = document.getElementById("pickup-store");
    if (storeSelect && s.store) storeSelect.value = s.store;

    const dateInput = document.getElementById("pickup-date");
    const dateDisplay = document.getElementById("pickup-date-display");

    if (dateInput && s.date) dateInput.value = s.date;
    if (dateDisplay && s.date) {
      dateDisplay.value = HGW.utils.formatEnglishDate(
        HGW.utils.parseISOLocal(s.date)
      );
    }

    const timeInput = document.getElementById("pickup-time");
    const timeDisplay = document.getElementById("pickup-time-display");

    if (timeInput && s.time) timeInput.value = s.time;
    if (timeDisplay && s.time) timeDisplay.value = s.time;

    const note = document.getElementById("order-note");
    if (note && typeof s.note === "string") note.value = s.note;

    /* ==========================
      Restore Delivery Address
    ========================== */

    if (s.method === "delivery" && s.delivery) {
      const addrInput = document.getElementById("delivery-address");
      const suburbInput = document.getElementById("delivery-suburb");
      const postcodeInput = document.getElementById("delivery-postcode");
      const extraInput = document.getElementById("delivery-address-extra");

      if (addrInput && s.delivery.address) {
        addrInput.value = s.delivery.address;
      }

      if (suburbInput && s.delivery.suburb) {
        suburbInput.value = s.delivery.suburb;
      }

      if (postcodeInput && s.delivery.postcode) {
        postcodeInput.value = s.delivery.postcode;
      }

      if (extraInput && s.delivery.address_extra) {
        extraInput.value = s.delivery.address_extra;
      }
    }

    /* ==========================
      Restore Validation (Date + Time)
    ========================== */

    if (
      s.method === "pickup" &&
      s.store &&
      s.date &&
      HGW.schedule?.buildSlots
    ) {
      const dateWarn = document.getElementById("hgw-date-warning");
      const timeWarn = document.getElementById("hgw-time-warning");

      const store = this.getStoreByCode(s.store);

      const slots = HGW.schedule.buildSlots({
        store,
        dateStr: s.date
      });

      if (!slots || slots.length === 0) {
        HGW.state.update({ date: "", time: "" });

        const di = document.getElementById("pickup-date");
        const dd = document.getElementById("pickup-date-display");
        const ti = document.getElementById("pickup-time");
        const td = document.getElementById("pickup-time-display");

        if (di) di.value = "";
        if (dd) dd.value = "";
        if (ti) ti.value = "";
        if (td) td.value = "";

        if (dateWarn) {
          dateWarn.textContent =
            "The previously selected pickup date is no longer available. Please choose a new date.";
          dateWarn.style.display = "block";
        }
        if (timeWarn) timeWarn.style.display = "none";

        forcedStep = 3;
        return forcedStep;
      }

      if (s.time) {
        const isValidTime = slots.some(
          slot => !slot.disabled && slot.value === s.time
        );

        if (!isValidTime) {
          HGW.state.update({ time: "" });

          const ti = document.getElementById("pickup-time");
          const td = document.getElementById("pickup-time-display");
          if (ti) ti.value = "";
          if (td) td.value = "";

          if (timeWarn) {
            timeWarn.textContent =
              "The previously selected pickup time is no longer available. Please choose a new time.";
            timeWarn.style.display = "block";
          }
          if (dateWarn) dateWarn.style.display = "none";

          forcedStep = 4;
          return forcedStep;
        }
      }

      if (dateWarn) dateWarn.style.display = "none";
      if (timeWarn) timeWarn.style.display = "none";
    }

    /* ==========================
      Restore Delivery Step3/4
    ========================== */

    if (s.method === "delivery" && s.delivery) {
      const policyCheckbox = document.getElementById("hgw-policy-agree");
      if (policyCheckbox) {
        policyCheckbox.checked = !!s.delivery.policy_agreed;
      }
      const signatureCheckbox = document.getElementById("hgw-signature-checkbox");
      if (signatureCheckbox) {
        signatureCheckbox.checked = !!s.delivery.signature_required;
      }
    }

    return forcedStep;
  }
};

/* ==========================
   Global Open / Close
========================== */

window.HGW.open = function (goCheckout) {
  if (window.HGW?.core?.open) {
    window.HGW.core.open(goCheckout);
  }
};

window.HGW.close = function () {
  window.HGW.core?.close();
};

/* ==========================
   Back Navigation Fix
========================== */

window.addEventListener("pageshow", function () {
  window.__HGW_GOING_CHECKOUT__ = false;
});

HGW.core.getCartSignature = async function () {
  const cart = await fetch("/cart.js", { cache: "no-store" }).then(r => r.json());
  const sig = (cart.items || [])
    .filter(i => i?.properties?._hgw_shipping !== "true")
    .map(i => `${i.variant_id}:${i.quantity}`)
    .sort()
    .join("|");

  return sig;
};